<template>
    <span :class="$getModuleTextColor ? $getModuleTextColor() : 'text-primary'">
        <font-awesome-icon
            icon="circle-notch"
            spin
            :class="iconClasses"
            :size="size === 'md' ? null : size" />
    </span>
</template>

<script>
export default {
    name: "DefaultSpinner",
    props: {
        size: {
            type: String,
            default: "md"
        },
        iconClasses: {
            type: String,
            default: null
        }
    }
}
</script>

<style scoped>

</style>
